module.exports = __webpack_public_path__ + "img/delete.7345261e.svg";